<div class="p-20">
  <app-card padding="10" [showHeader]="false">
    <div class="col-12 col-md-12">
      <div class="grid">
        <button
          mat-flat-button color="primary"
          class="mat-body f-w-500"
          [disabled]="isSubmitting"
          (click)="onSubmit()"
        >
          @if (isSubmitting) {
            {{ 'Guardando ...' }}
          } @else {
            {{ 'Guardar' }}
          }
        </button>
      </div>

    </div>
  </app-card>

  <app-clipboard-pane namespace="hardware.sensors" [(value)]="sensors" />


  @for (sensor of sensors; track sensor._id) {
    <app-card [showHeader]="false" padding="10" [style.opacity]="sensor?.config?.enable ? 1: 0.5">
      <div>
        <mat-slide-toggle
          color="success"
          [checked]="sensor.config?.enable"
          (change)="sensor.config.enable = !sensor?.config?.enable"
        >
          <label>{{ sensor.label?.['es'] || sensor.label?.['default'] }}</label>
        </mat-slide-toggle>
      </div>

      @if(sensor.config?.enable){
        <br/>

        <app-field-expression
          [label]="'Configuracion'"
          [inputOptionsUrl]="inputOptionsUrl"
          [value]="sensor.config?.expression"
          (valueChange)="sensor.config.expression = $event"
        />

        <div>
          <br/>
          <mat-slide-toggle
            color="success"
            [checked]="sensor?.config?.editable"
            (change)="sensor.config.editable = !sensor.config?.editable"
          >
            <label>Editable por el usuario</label>
          </mat-slide-toggle>
        </div>
      }

    </app-card>
  }


</div>
